import { Box, Card, CardBody, SimpleGrid, Stack, Text } from "@chakra-ui/react";

import React from "react";

const ReportExpenseCard = ({
  title = "",
  percentage = "0.00",
  total = "0.00",
  perfectPL = "0.00",
  color = "black",
}) => {
  return (
    <Stack width="100%" align="center" p="0px 0px">
      <Card
        role="group"
        boxShadow="none"
        width="100%"
        height={"139px"}
        borderRadius="12px"
        outline={"1px solid #CBD5E0"}
      >
        <CardBody boxShadow="none" padding={"6px"}>
          <Box align={"center"}>
            <Text
              gridColumn={1}
              gridRow={1}
              fontSize="16px"
              margin={0}
              textAlign="center"
              color={"#202224"}
            >
              {title}
            </Text>
            <Text fontSize={"28px"} fontWeight={800} margin={0} color={color}>
              {percentage}
            </Text>
          </Box>
          <SimpleGrid
            templateColumns={"14fr 5fr 14fr"}
            align="center"
            p={"5px 0px 0px"}
          >
            <Box
              p={0}
              height={"60px"}
              gridColumn={1}
              gridRow={1}
              textAlign={"center"}
            >
              <Text fontSize={"15px"} margin={0} color={"#202224"}>
                Perfect P&L
              </Text>
              <Text
                fontSize={"18px"}
                fontWeight={600}
                margin={0}
                gridColumn={1}
                gridRow={2}
                whiteSpace={"nowrap"}
              >
                Below {perfectPL}
              </Text>
            </Box>
            <Box
              textAlign={"center"}
              align={"center"}
              justifyContent={"center"}
              display={"flex"}
            >
              <Box
                gridColumn={2}
                gridRow={1}
                height={"50px"}
                borderLeft={"1px solid"}
                borderColor={"gray.200"}
                width="0px"
              ></Box>
            </Box>
            <Box gridColumn={3} gridRow={1} textAlign={"center"}>
              <Text fontSize={"15px"} margin={0} color={"#202224"}>
                Total
              </Text>
              <Text
                fontSize={"18px"}
                fontWeight={600}
                margin={0}
                gridColumn={2}
                gridRow={2}
                whiteSpace={"nowrap"}
              >
                {total}
              </Text>
            </Box>
          </SimpleGrid>
        </CardBody>
      </Card>
    </Stack>
  );
};

export default ReportExpenseCard;
